import { AbstractControl, ValidatorFn } from '@angular/forms';
import { ValidatorPatterns } from '../validator-patterns/validator-patterns.class';

export const email = (): ValidatorFn => {
    return (currentControl: AbstractControl): { [key: string]: any } => {
        if (!ValidatorPatterns.EMAIL_VALIDATION_PATTERN.test(currentControl.value)) {
            return { email: true };
        }
        return null;
    };
};
